import Fieldset from "@/components/Fieldset";
import { DateRangeField } from "@/modules/projects/components/schedules/fields/DateRangeField";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import CheckboxField from "@/components/CheckboxField";
import { useFormContext } from "react-hook-form";
import { ProjectSchedulesDeleteFormData } from "@/types/projectSchedulesDeleteForm";

const ProjectSchedulesDeleteDialogFormComponent = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext<ProjectSchedulesDeleteFormData>();
  const deleteAll = watch("delete_all");

  return (
    <>
      <Fieldset className="grid grid-cols-1 lg:grid-cols-2 m-0">
        <DateRangeField disabled={deleteAll} />
      </Fieldset>
      <Fieldset className="flex flex-col md:flex-row gap-4 items-end m-0">
        <div className="flex-[3] text-sm text-muted-foreground flex flex-col gap-1">
          <div className="text-destructive">
            {t("projectSchedules.deleteWarning.line1")}
          </div>
          <div className="text-destructive">
            {t("projectSchedules.deleteWarning.line2")}
          </div>
          <div className="text-destructive">
            <b>{t("projectSchedules.deleteWarning.line3")}</b>
          </div>
        </div>
        <div className="flex-1 flex items-center">
          <CheckboxField
            className="flex flex-row-reverse justify-end items-center text-destructive"
            name="delete_all"
            label={t("projectSchedules.fields.delete_whole_schedule")}
          />
        </div>
      </Fieldset>
    </>
  );
};

export const ProjectSchedulesDeleteDialogForm = memo(
  ProjectSchedulesDeleteDialogFormComponent,
);
